var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"text-center"},[_vm._v(" Kakao Log In")]),_c('br'),_c('img',{attrs:{"src":require("@/assets/img/member/kakao_login_medium_narrow.png")},on:{"click":function($event){return _vm.openKakaoLogin()}}}),_c('br'),_c('br'),_c('router-link',{attrs:{"to":"/"}},[_vm._v("뒤로 가기")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }